export const base_url = "https://api.powerofdiaspora.com/";
export const image_base_url = base_url + "uploads/images/";
export const image_base_url_files = base_url + "uploads/files/";
